import React, { useEffect } from 'react'

import classnames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'

import { redirect } from 'actions/redirect'
import { useIsOptimizelyFeatureEnabled } from 'containers/OptimizelyRollouts'
import { useDoubleDeckerNav } from 'hooks/useDoubleDeckerNav'
import { useBasket } from 'routes/Menu/domains/basket'
import { getIsAuthenticated } from 'selectors/auth'
import { getIsPolicyAccepted } from 'selectors/cookies'
import { getIsLandOnMenuEnabled } from 'selectors/features'

import { useCollections } from '../../domains/collections'
import { CollectionsNav } from './CollectionsNav'
import { useTracking } from './useTracking'

import css from './CollectionsNav.css'

type CollectionsNavWrapperProps = {
  user: {
    nameFirst: string
  }
}

const CollectionsNavWrapper = (ownProps: CollectionsNavWrapperProps) => {
  const isLandOnMenuFeatureEnabled = useSelector(getIsLandOnMenuEnabled)
  const isAuthenticated = useSelector(getIsAuthenticated)
  const { currentCollectionId, collections, changeCollectionById } = useCollections()
  const isPolicyAccepted = useSelector(getIsPolicyAccepted)
  const { menuId } = useBasket()
  const doubleDeckerExperimentEnabled = useDoubleDeckerNav()
  const isCuratedBoxesV2FeatureEnabled = useIsOptimizelyFeatureEnabled(
    'beetroots_is_curated_boxes_v2_enabled',
  )
  const track = useTracking({ collections, menuId })
  useEffect(() => track(), [track])

  const isLandOnMenuEnabled = !isAuthenticated && isLandOnMenuFeatureEnabled
  const isCuratedBoxesV2Enabled = !isAuthenticated && isCuratedBoxesV2FeatureEnabled

  const dispatch = useDispatch()

  const collectionItemOnClickCuratedBoxes = () => dispatch(redirect('/menu/curated-boxes'))

  return (
    <div
      className={classnames({
        [css.doubleDeckerCollectionsNavWrapper]: doubleDeckerExperimentEnabled,
      })}
    >
      <CollectionsNav
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...ownProps}
        isLandOnMenuEnabled={isLandOnMenuEnabled}
        changeCollectionById={changeCollectionById}
        menuCollections={collections}
        menuCurrentCollectionId={currentCollectionId}
        isPolicyAccepted={isPolicyAccepted}
        doubleDeckerExperimentEnabled={doubleDeckerExperimentEnabled}
        isCuratedBoxesV2Enabled={isCuratedBoxesV2Enabled}
        collectionItemOnClickCuratedBoxes={collectionItemOnClickCuratedBoxes}
      />
    </div>
  )
}

export { CollectionsNavWrapper }
